export default __webpack_public_path__ + "fa-regular-400.ttf";